import { Divider } from "antd"
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline"
import { IShiftSwapRequest } from "../interface/shiftData"
import { ShiftSwapCard } from "./ShiftSwapCard"

type SwapWithPerspective = IShiftSwapRequest & {
  perspective: "sender" | "receiver"
}

interface Props {
  section: {
    key: string
    label: string
    swaps: SwapWithPerspective[]
  }
  isOpen: boolean
  onToggle: () => void
  onViewRequest: (swap: SwapWithPerspective) => void
}

export const ShiftSwapCollapse = ({
  section,
  isOpen,
  onToggle,
  onViewRequest,
}: Props) => (
  <div className="font-circular border-b-4 border-[#F1F5F9]">
    <button
      onClick={onToggle}
      className="flex items-center justify-between w-full px-3 py-2 text-sm font-bold text-[#0F172B]"
    >
      <span>{section.label}</span>
      {isOpen ? (
        <ChevronUpIcon className="w-4 h-4 text-[#62748E]" />
      ) : (
        <ChevronDownIcon className="w-4 h-4 text-[#62748E]" />
      )}
    </button>
    {isOpen && section.swaps.length === 0 && (
      <p className="px-3 pb-3 text-sm text-[#62748E]">No requests</p>
    )}
    {isOpen &&
      section.swaps.map((swap) => (
        <div key={swap.id}>
          <Divider style={{ margin: "10px 0" }} />
          <ShiftSwapCard
            swap={swap}
            perspective={swap.perspective}
            onViewRequest={() => onViewRequest(swap)}
          />
        </div>
      ))}
  </div>
)
